import React from 'react';
import Routes from './components/Routes';
import { ConfirmDialogProvider } from './components/common/ConfirmDialogProvider';
import { ToastProvider } from './components/common/ToastProvider';
import { initializeIcons } from '@uifabric/icons';
import {
  loadTheme,
  registerIcons,
  registerIconAlias,
} from 'office-ui-fabric-react';
import 'office-ui-fabric-react/dist/css/fabric.min.css';
// import './topCss.css';
import { THEME } from './utils/Styles';
// import Icon from "@mdi/react";
// import { mdiHomeOutline, mdiServerNetwork, mdiAccountGroupOutline, mdiAccountMultiple, mdiAccountMultipleOutline } from "@mdi/js";
import { ICONS } from './utils/Icons';
import ErrorBoundary from './components/common/ErrorBounday';
// 🚫 PASSWORD EXPIRY — the post-login "your password expires in N days" alert is
// DISABLED. This mount is the whole switch: the provider was mounted app-wide
// only so LoginMain could summon the dialog through its context. Unmounted, it
// can never appear.
//
// The client asked for the nagging to go — with Microsoft SSO as the primary
// path, prompting users about a credential they never type is noise.
//
// components/change-password/PasswordChangeAlertProvider.tsx is deliberately
// LEFT INTACT: it is unreferenced dead code now, so the file stays readable and
// its history stays intact. Re-enabling is uncommenting this import, the
// wrapper below, and the trigger in components/auth/LoginMain.tsx.
// import { PasswordChangeAlertProvider } from './components/change-password/PasswordChangeAlertProvider';
// import {Icons} from "./utils/icons";
initializeIcons();
loadTheme(THEME);
registerIcons({
  icons: ICONS,
});
registerIconAlias('Search', 'SearchMdn');
registerIconAlias('ChevronDown', 'ChevronDownMdn');
registerIconAlias('ChromeClose', 'ChromeCloseMdn');
registerIconAlias('ChevronRightMed', 'ChevronRightMedMdn');
registerIconAlias('More', 'MoreMdn');

const App: React.FC = () => {
  return (
    <div>
      <ErrorBoundary>
        <ConfirmDialogProvider>
          {/* 🚫 PASSWORD EXPIRY — <PasswordChangeAlertProvider> wrapper removed;
              the tree below is unchanged. See the import note above. */}
          <ToastProvider>
            <Routes />
          </ToastProvider>
        </ConfirmDialogProvider>
      </ErrorBoundary>
    </div>
  );
};

export default App;
